module.exports = __webpack_public_path__ + "static/media/salesTerms.8351fd54.pdf";